import React from 'react';
import * as S from './styled';
import { TabPillsItem } from './TabPillsItem';
export const TabPills = ({ appearance = 'primary', size = 'regular', options, value, onChange, }) => (React.createElement(S.Container, null, options.map((option) => (React.createElement(TabPillsItem, { key: option.value, appearance: appearance, size: size, label: option.label, active: option.value === value, onClick: () => onChange(option.value) })))));
